import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { PrimaryNavItem } from '@hdms/shared/page-frame/types';

/**
 * Render header menu links for SEO
 */
@Component({
  selector: '[shrd-pf-ft-menu-seo-only-links]',
  templateUrl: './header-menu-seo-only-links.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderMenuSeoOnlyLinksComponent {
  @Input() primaryNavItems: PrimaryNavItem[];

  @HostBinding('class.visually-hidden') readonly hostClass = true;
}
